import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

type CircleCloseProps = IconProps & {
	backgroundColor?: string;
};

export const CircleClose: FC<CircleCloseProps> = ({ color = "#344054", ...props }) => {
	return (
		<Svg viewBox="0 0 22 22" fill={"white"} {...props}>
			<path
				d="M13.9994 14L11 11.0003M11 11.0003L8 8M11 11.0003L8.00064 14M11 11.0003L14 8M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z"
				stroke={color}
				stroke-width="2"
				stroke-linecap="round"
			/>
		</Svg>
	);
};

export const RedCircleClose = () => {
	return (
		<Svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.9994 14L11 11.0003M11 11.0003L8 8M11 11.0003L8.00064 14M11 11.0003L14 8M21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11Z"
				stroke="white"
				stroke-width="2"
				stroke-linecap="round"
			/>
		</Svg>
	);
};
